import { render } from "./TheNavbar.vue?vue&type=template&id=046f9344&scoped=true"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"

import "./TheNavbar.vue?vue&type=style&index=0&id=046f9344&scoped=true&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046f9344"]])

export default __exports__